export default class OutboundTransactionCommissionSummaryDTO {

    constructor(jsonResponse) {
        if (jsonResponse) {
            this.transactionCount = jsonResponse["transaction-count"];
            this.randCapitalAmount = jsonResponse["rand-capital-amount"];
            this.commissionRandAmount = jsonResponse["commission-rand-amount"];
            this.commissionPercentage = jsonResponse["commission-percentage"];
            this.year = jsonResponse["year"];
            this.month = jsonResponse["month"];
        }
    }
}
